import {Navigate} from 'react-router-dom';

const PostAccountSetup = () => {
  return <Navigate to="/home" />;
};

export default PostAccountSetup;
